import { render, staticRenderFns } from "./DescriptionRead.vue?vue&type=template&id=55fa7289&scoped=true&"
import script from "./DescriptionRead.vue?vue&type=script&lang=js&"
export * from "./DescriptionRead.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionRead.vue?vue&type=style&index=0&id=55fa7289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa7289",
  null
  
)

export default component.exports